import { useEffect } from "react";
import { useTranslation } from 'react-i18next';

const STORAGE_LANGUAGE_KEY = 'Lang'

function useLanguage() {
    const tran = useTranslation();
    const { i18n } = tran

    // console.log({i18n})

    const resources = tran.i18n.store.data

    // i18n.language
    // const [anchorEl, setAnchorEl] = useState(() => {
        
    //     let initLang = window.localStorage.getItem("Lang");
    //     if (!initLang) {
    //         const lang = navigator?.languages[1];
    //         // if (configurationOfLanguageList.includes(lang)) {
    //         //     initLang = lang.toLocaleUpperCase()
    //         // }
    //         // else {
    //         //     initLang = 'EN'
    //         // }
    //         initLang = resources[lang] ? lang : 'en'
    //     }
    //     return initLang
    // });

    const checkoutLanguage = (language) => {
        window.localStorage.setItem(STORAGE_LANGUAGE_KEY, language);
        i18n.changeLanguage(language);
    }

    useEffect(() => {
        window.localStorage.setItem(STORAGE_LANGUAGE_KEY, i18n.language);
    }, [i18n.language])

    return {
        lang: i18n.language,
        resources: Object.keys(resources),
        // langName: 
        checkoutLanguage
    }
}

export default useLanguage
